// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDiGKwmQPkCFls5AljAgffYe9a5HY1vIoU',
  authDomain: 'woor-fa069.firebaseapp.com',
  projectId: 'woor-fa069',
  storageBucket: 'woor-fa069.firebasestorage.app',
  messagingSenderId: '823477250842',
  appId: '1:823477250842:web:0b9a42dc7d8b5e8a765aa3',
  measurementId: 'G-JMLE7Q82HM',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
